
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/my-account",
      function () {
        return require("private-next-pages/profile/my-account/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/my-account"])
      });
    }
  